/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLocationDirectly: {
  name: 'location-directly';
  data: string;
} = {
  name: 'location-directly',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 .5a.5.5 0 0 1 .447.276l7 14a.5.5 0 0 1-.695.658L8 11.576l-6.752 3.858a.5.5 0 0 1-.695-.658l7-14A.5.5 0 0 1 8 .5ZM2.186 13.747l5.566-3.181a.5.5 0 0 1 .496 0l5.566 3.18L8 2.119 2.186 13.747Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
